import angular from "angular";
import { IHttpRestConfig } from "./IHttpRestConfig";

export class IRestServiceConfig {
    serviceConfigs: { [name: string]: IHttpRestConfig };
    retryMaxTime: number;
    retryTimeSpan: number;
    defaultHeaders: angular.IHttpRequestConfigHeaders;
}